import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Store } from "lucide-react";
import AddressAutocomplete from "@/components/AddressAutocomplete";

const KEEP = ["name", "address", "canton", "vat_number", "covers_per_day", "logo_data_url", "vat_method", "tdfn_rate_1", "tdfn_rate_2", "fiduciary_email", "closed_weekdays", "closures"];
const CANTONS = ["VD","GE","FR","NE","JU","VS","BE","ZH","BS","BL","AG","SO","SG","TI","LU","ZG","SH","TG","GR","UR","SZ","OW","NW","GL","AR","AI"];

export default function EstablishmentCard() {
  const { t } = useTranslation();
  const [est, setEst] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/establishment").then(({ data }) => data && setEst(data)).catch(() => {}); }, []);
  if (!est) return null;
  const save = async () => {
    setBusy(true);
    try {
      const body = Object.fromEntries(KEEP.filter((k) => est[k] !== undefined && est[k] !== null).map((k) => [k, est[k]]));
      await api.post("/establishment", body);
      toast.success(t("est.saved"));
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="card-c space-y-3" data-testid="profile-establishment-card">
      <div className="flex items-center gap-2">
        <Store className="w-5 h-5 text-primary-c" />
        <p className="text-xs uppercase tracking-wider text-text-secondary font-semibold">{t("est.title")}</p>
      </div>
      <label className="block text-sm text-text-secondary">{t("onb.name")}
        <input value={est.name || ""} onChange={(e) => setEst({ ...est, name: e.target.value })} className="input-c mt-1" data-testid="est-name" /></label>
      <div className="text-sm text-text-secondary">{t("address.label")}
        <div className="mt-1"><AddressAutocomplete value={est.address || ""} onChange={(x) => setEst((p) => ({ ...p, ...x }))} testPrefix="est-address" /></div></div>
      <label className="block text-sm text-text-secondary">{t("onb.canton")}
        <select value={est.canton || "VD"} onChange={(e) => setEst({ ...est, canton: e.target.value })} className="input-c mt-1" data-testid="est-canton">{CANTONS.map((c) => <option key={c}>{c}</option>)}</select></label>
      <button onClick={save} disabled={busy} className="btn-primary w-full text-sm" data-testid="est-save">{busy ? t("onb.saving") : t("admin.save")}</button>
    </div>
  );
}
